import { render } from "./ModalAlertAttivo.vue?vue&type=template&id=3b1544c9&ts=true"
import script from "./ModalAlertAttivo.vue?vue&type=script&lang=ts"
export * from "./ModalAlertAttivo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__